import { createInertiaApp } from '@inertiajs/svelte'

createInertiaApp({
  pages: '../pages',

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: 'brackets' }
    },
  },
})
